export const CardsContent1 = [
  {
    label: "Giftcard",
    title: "Amazon Gift Card",
    content:
      "Amazon Gift Card is a global fashion destination for 20-somethings, selling all the freshest styles complemented by exclusive content....",
    info: "This card has a fee of $ 0.99",
    btn: "Purchase card",
  },
  {
    label: "Giftcard",
    title: "Amazon Gift Card",
    content:
      "Amazon Gift Card is a global fashion destination for 20-somethings, selling all the freshest styles complemented by exclusive content....",
    info: "This card has a fee of $ 0.99",
    btn: "Purchase card",
  },
  {
    label: "Giftcard",
    title: "Amazon Gift Card",
    content:
      "Amazon Gift Card is a global fashion destination for 20-somethings, selling all the freshest styles complemented by exclusive content....",
    info: "This card has a fee of $ 0.99",
    btn: "Purchase card",
  },
  {
    label: "Giftcard",
    title: "Amazon Gift Card",
    content:
      "Amazon Gift Card is a global fashion destination for 20-somethings, selling all the freshest styles complemented by exclusive content....",
    info: "This card has a fee of $ 0.99",
    btn: "Purchase card",
  },
];
export const CardsContent2 = [
  {
    label: "Giftcard",
    title: "Amazon Gift Card",
    content:
      "Amazon Gift Card is a global fashion destination for 20-somethings, selling all the freshest styles complemented by exclusive content....",
    info: "This card has a fee of $ 0.99",
    btn: "Purchase card",
  },
  {
    label: "Giftcard",
    title: "Amazon Gift Card",
    content:
      "Amazon Gift Card is a global fashion destination for 20-somethings, selling all the freshest styles complemented by exclusive content....",
    info: "This card has a fee of $ 0.99",
    btn: "Purchase card",
  },
  {
    label: "Giftcard",
    title: "Amazon Gift Card",
    content:
      "Amazon Gift Card is a global fashion destination for 20-somethings, selling all the freshest styles complemented by exclusive content....",
    info: "This card has a fee of $ 0.99",
    btn: "Purchase card",
  },
  {
    label: "Giftcard",
    title: "Amazon Gift Card",
    content:
      "Amazon Gift Card is a global fashion destination for 20-somethings, selling all the freshest styles complemented by exclusive content....",
    info: "This card has a fee of $ 0.99",
    btn: "Purchase card",
  },
];
export const CardContents3 = [
  {
    label: "Giftcard",
    title: "Amazon Gift Card",
    content:
      "Amazon Gift Card is a global fashion destination for 20-somethings, selling all the freshest styles complemented by exclusive content....",
    info: "This card has a fee of $ 0.99",
    btn: "Purchase card",
  },
  {
    label: "Giftcard",
    title: "Amazon Gift Card",
    content:
      "Amazon Gift Card is a global fashion destination for 20-somethings, selling all the freshest styles complemented by exclusive content....",
    info: "This card has a fee of $ 0.99",
    btn: "Purchase card",
  },
  {
    label: "Giftcard",
    title: "Amazon Gift Card",
    content:
      "Amazon Gift Card is a global fashion destination for 20-somethings, selling all the freshest styles complemented by exclusive content....",
    info: "This card has a fee of $ 0.99",
    btn: "Purchase card",
  },
  {
    label: "Giftcard",
    title: "Amazon Gift Card",
    content:
      "Amazon Gift Card is a global fashion destination for 20-somethings, selling all the freshest styles complemented by exclusive content....",
    info: "This card has a fee of $ 0.99",
    btn: "Purchase card",
  },
];
